import React, { Fragment } from 'react';
import Content from '../shared/content';
import useButtonBase from '../shared/use-button-base';
/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */
var useDefaultButton = function useDefaultButton(_ref) {
  var analyticsContext = _ref.analyticsContext,
    appearance = _ref.appearance,
    autoFocus = _ref.autoFocus,
    buttonType = _ref.buttonType,
    IconBefore = _ref.iconBefore,
    UNSAFE_iconBefore_size = _ref.UNSAFE_iconBefore_size,
    IconAfter = _ref.iconAfter,
    UNSAFE_iconAfter_size = _ref.UNSAFE_iconAfter_size,
    interactionName = _ref.interactionName,
    isDisabled = _ref.isDisabled,
    isSelected = _ref.isSelected,
    children = _ref.children,
    onClick = _ref.onClick,
    onMouseDownCapture = _ref.onMouseDownCapture,
    onMouseUpCapture = _ref.onMouseUpCapture,
    onKeyDownCapture = _ref.onKeyDownCapture,
    onKeyUpCapture = _ref.onKeyUpCapture,
    onTouchStartCapture = _ref.onTouchStartCapture,
    onTouchEndCapture = _ref.onTouchEndCapture,
    onPointerDownCapture = _ref.onPointerDownCapture,
    onPointerUpCapture = _ref.onPointerUpCapture,
    onClickCapture = _ref.onClickCapture,
    overlay = _ref.overlay,
    ref = _ref.ref,
    shouldFitContainer = _ref.shouldFitContainer,
    spacing = _ref.spacing;
  var hasOverlay = Boolean(overlay);
  var baseProps = useButtonBase({
    analyticsContext: analyticsContext,
    appearance: appearance,
    autoFocus: autoFocus,
    buttonType: buttonType,
    children: /*#__PURE__*/React.createElement(Fragment, null, IconBefore && /*#__PURE__*/React.createElement(Content, {
      type: "icon",
      hasOverlay: hasOverlay
    }, /*#__PURE__*/React.createElement(IconBefore, {
      label: "",
      size: UNSAFE_iconBefore_size
    })), children && /*#__PURE__*/React.createElement(Content, {
      hasOverlay: hasOverlay
    }, children), IconAfter && /*#__PURE__*/React.createElement(Content, {
      type: "icon",
      hasOverlay: hasOverlay
    }, /*#__PURE__*/React.createElement(IconAfter, {
      label: "",
      size: UNSAFE_iconAfter_size
    }))),
    interactionName: interactionName,
    isDisabled: isDisabled,
    isSelected: isSelected,
    onClick: onClick,
    onMouseDownCapture: onMouseDownCapture,
    onMouseUpCapture: onMouseUpCapture,
    onKeyDownCapture: onKeyDownCapture,
    onKeyUpCapture: onKeyUpCapture,
    onTouchStartCapture: onTouchStartCapture,
    onTouchEndCapture: onTouchEndCapture,
    onPointerDownCapture: onPointerDownCapture,
    onPointerUpCapture: onPointerUpCapture,
    onClickCapture: onClickCapture,
    overlay: overlay,
    ref: ref,
    shouldFitContainer: shouldFitContainer,
    spacing: spacing,
    hasIconBefore: Boolean(IconBefore),
    hasIconAfter: Boolean(IconAfter)
  });
  return baseProps;
};
export default useDefaultButton;